import type { ConnectorConnection } from '@saaga/shared/interfaces/connector.interface'
import type { ReactNode } from 'react'
import { ConfirmDialog } from '@/components/molecules/confirm-dialog.molecule'

export interface DisconnectConnectorDialogProps {
  connection: ConnectorConnection | null
  onClose: () => void
  onConfirm: () => Promise<void>
}

/**
 * Confirmation dialog for disconnecting a connector.
 * Controlled via the connection prop — null means closed.
 */
export const DisconnectConnectorDialog: React.FC<DisconnectConnectorDialogProps> = ({
  connection,
  onClose,
  onConfirm,
}): ReactNode => (
  <ConfirmDialog
    isOpen={connection !== null}
    onOpenChange={(isOpen) => !isOpen && onClose()}
    title="Disconnect Connector"
    description={`Are you sure you want to disconnect ${connection?.providerAccountId ?? 'this connection'}? This will revoke access and remove all associated projects.`}
    confirmLabel="Disconnect"
    onConfirm={onConfirm}
    variant="destructive"
  />
)

DisconnectConnectorDialog.displayName = 'DisconnectConnectorDialog'
